import { useAuthContext } from '../contexts/auth';
import * as utils from '@deque/billing-utils';

interface useCurrentSubscriptionParams {
  /* Product slug to get the current subscription for */
  productSlug: utils.ProductSlugs;
}

const useCurrentSubscription = ({
  productSlug
}: useCurrentSubscriptionParams): utils.Subscription | null => {
  const { billingUser } = useAuthContext();

  // We require the billing user to be present to fetch the current subscription.
  if (!billingUser) {
    return null;
  }

  const currentSubscription = utils.getControllingProductSubscription(
    billingUser,
    productSlug
  );

  return currentSubscription;
};

export default useCurrentSubscription;
